import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { getTokenExpiry } from "./TimeUtility";

export default function RequireAuth() {
    const location = useLocation();

    if (!isAuthenticated()) {
        return (
            <Navigate
                to="/unauthorized"
                replace
                state={{
                    from: location.pathname,
                    message: "Your session is not active. Please login to continue.",
                }}
            />
        );
    }

    return <Outlet />;
}

export const isAuthenticated = () => {
    const token = sessionStorage.getItem("token");
    if (!token) return false;

    const cookieTokenTime = Number(sessionStorage.getItem("tokenTime"));
    const tokenExpiry = Number.isFinite(cookieTokenTime) && cookieTokenTime > 0
        ? cookieTokenTime
        : getTokenExpiry(token);

    if (!tokenExpiry || tokenExpiry <= Date.now()) {
        clearAuthSession();
        return false;
    }

    return true;
};

export const clearAuthSession = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("tokenTime");
    sessionStorage.removeItem("refreshTokenTime");
    sessionStorage.clear();
};
